import {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonBackButton,
    IonButtons,
} from '@ionic/react'

export default ({ title, ...props }) => (
    <IonHeader>
        <IonToolbar>
            <IonTitle>{title}</IonTitle>
            <IonButtons slot="start">
                <IonBackButton text="" defaultHref="/" {...props} />
            </IonButtons>
        </IonToolbar>
    </IonHeader>
)
